package components.project

enum class DefaultFilteredBy {
  Maintainer,
  Editor,
}
